import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Formik, ErrorMessage } from 'formik'
import _ from 'lodash'

import { Button, TextInput } from '../../../shard'
import { Color } from '../../../../const'

import Alert from 'components/Alert'

import { usePasswordHook } from 'hooks'

function Password() {
  const [values, setValues] = useState({})
  const { errors, setErrors, sendmailSchema, execSendMail, isSendingMail, isSuccess, history } = usePasswordHook()

  useEffect(() => {
    if (_.isEmpty(values)) {
      return
    }

    execSendMail(values.tanakaId)
  }, [values, execSendMail])

  useEffect(() => {
    if (isSuccess) {
      history.push('/password/sendmail')
    }
  }, [history, isSuccess])

  return (
    <Wrapper>
      <Message>TANAKA-ID ご来店時登録いただいたID（メールアドレス）を入力してください</Message>
      {errors.length > 0 && (
        <Alert type="error" message="エラー" description={errors.join('\n')} onClose={() => setErrors([])} />
      )}
      <FormWrapper>
        <Formik
          initialValues={{ tanakaId: '' }}
          onSubmit={(values) => {
            setValues(values)
          }}
          validationSchema={sendmailSchema}
        >
          {({ values, handleChange, handleBlur, handleSubmit, dirty, isSubmitting, isValid }) => (
            <form
              onSubmit={(e) => {
                handleSubmit(e)
                e.preventDefault() // useEffectでstateを更新するためにcomponentの自動更新を防ぐ
              }}
            >
              <TextInput
                type="email"
                name="tanakaId"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.tanakaId}
                ariaLabel="tanakaId"
                placeholder="TANAKA-ID（メールアドレス）"
                errorMessage={<ErrorMessage name="tanakaId" />}
              />
              <ButtonWrapper>
                <Button type={'submit'} primary disabled={!isValid || !dirty || isSendingMail}>
                  確認メール送信
                </Button>
              </ButtonWrapper>
            </form>
          )}
        </Formik>
      </FormWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 30px 20px;
`

const Message = styled.div`
  padding: 10px 0;
  color: ${Color.FONT.ANNOTATION};
`

const FormWrapper = styled.div`
  grid-column: 2;
  grid-row: 3;
  padding-top: 20px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
`

Password.propTypes = {
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  dirty: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
}

export default Password
